module.exports = __webpack_public_path__ + "img/loopHover.6b954850.svg";